import { CloseRounded } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { action, API, controller } from "api";
import { Button } from "controls";
import { ToFormData } from "hooks";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const UpdateStatus = ({ setShowForm, selectedRec, showForm }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => {
    setShowForm((j) => ({ ...j, open: false }));
  };

  const handleSubmit = () => {
    setLoading(true);
    API(controller.Product + action.UpdateProductsStatus).post(
      ToFormData({
        all: selectedRec?.all,
        ids: selectedRec?.items,
        activeProduct: showForm.activeProduct,
      }),
      (res) => {
        if (res?.status === 200) {
          toast.success(
            `You have successfully ${
              showForm.activeProduct ? "activated" : "deactivated"
            } the selected products`
          );
          navigate(0);
          handleClose();
        }
        setLoading(false);
      }
    );
  };

  return (
    <div className="flex flex-col max-h-[90vh]">
      {/* ======= Header ======== */}
      <div className="flex justify-between items-center gap-2 border-b p-[2px]">
        <span className="text-[20px] ml-[10px] uppercase text-gray-600 font-medium">
          You're about to {showForm.activeProduct ? "activate" : "deactivate"}
          &nbsp;
          <span className="font-bold text-gray-700">
            {selectedRec.items.length}
          </span>{" "}
          products
        </span>
        <div className="flex gap-2 m-1">
          <IconButton size="small" onClick={handleClose}>
            <CloseRounded />
          </IconButton>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto flex flex-col gap-5 p-4">
        {showForm.activeProduct ? (
          <p className="text-gray-700">
            When active, these products (including variants) can be sold on the
            Sell screen.
          </p>
        ) : (
          <p className="text-gray-700">
            When inactive, these products (including variants) can’t be sold on
            the Sell screen.
          </p>
        )}

        <div className="flex flex-wrap gap-2 justify-end">
          <Button variant="text" onClick={handleClose}>
            Don't active
          </Button>
          <Button loading={loading} onClick={handleSubmit}>
            {showForm.activeProduct ? "Active" : "Deactive"} products
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UpdateStatus;
